/* ============================
   MFC Enhancements
   - Cart qty flash
   - Wedding gallery lightbox + keyboard nav
   ============================ */

(function () {
  // ---- CART: flash row when qty changes ----
  function initCartQtyFlash() {
    const cartForm = document.querySelector('.template-cart form[action*="/cart"]');
    if (!cartForm) return;

    cartForm.addEventListener('change', (e) => {
      const el = e.target;
      if (!el) return;

      // Only react to number inputs that look like qty fields
      if (el.matches('input[type="number"]')) {
        const row = el.closest('.cart__row, .cart-item, .cart__item, li, tr, .grid__item') || el.parentElement;
        if (!row) return;
        row.classList.remove('mfc-qty-flash');
        // reflow
        void row.offsetWidth;
        row.classList.add('mfc-qty-flash');
      }
    });
  }

  // ---- WEDDINGS: lightbox + arrows + esc ----
  function initWeddingLightbox() {
    const triggers = Array.from(document.querySelectorAll('[data-wedding-lightbox]'));
    const modal = document.querySelector('[data-wedding-lightbox-modal]');
    if (!triggers.length || !modal) return;

    const img = modal.querySelector('.wedding-lightbox__image');
    const closes = Array.from(modal.querySelectorAll('[data-wedding-lightbox-close]'));

    let index = -1;

    function openAt(i) {
      index = i;
      const a = triggers[index];
      const href = a.getAttribute('href');
      const caption = a.getAttribute('data-caption') || '';
      img.src = href;
      img.alt = caption || 'Wedding gallery image';

      modal.classList.add('is-active');
      modal.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
      document.body.style.overflow = 'hidden';
    }

    function close() {
      modal.classList.remove('is-active');
      modal.setAttribute('aria-hidden', 'true');
      img.src = '';
      document.documentElement.style.overflow = '';
      document.body.style.overflow = '';
      index = -1;
    }

    function next() {
      if (index < 0) return;
      openAt((index + 1) % triggers.length);
    }

    function prev() {
      if (index < 0) return;
      openAt((index - 1 + triggers.length) % triggers.length);
    }

    triggers.forEach((a, i) => {
      a.addEventListener('click', (e) => {
        e.preventDefault();
        openAt(i);
      });
    });

    closes.forEach((btn) => btn.addEventListener('click', close));

    document.addEventListener('keydown', (e) => {
      if (!modal.classList.contains('is-active')) return;
      if (e.key === 'Escape') close();
      if (e.key === 'ArrowRight') next();
      if (e.key === 'ArrowLeft') prev();
    });

    // click image = next (nice UX)
    img.addEventListener('click', () => next());
  }

  document.addEventListener('DOMContentLoaded', function () {
    initCartQtyFlash();
    initWeddingLightbox();
  });
})();
